"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypeVennData = exports.propTypeNumberOrString = exports.propTypeMargin = exports.propTypeGroupedSeries = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var propTypeNumberOrString = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]);
exports.propTypeNumberOrString = propTypeNumberOrString;
var propTypeGroupedSeries = _propTypes.default.arrayOf(_propTypes.default.shape({
  k: propTypeNumberOrString.isRequired,
  v: _propTypes.default.arrayOf(_propTypes.default.shape({
    k: propTypeNumberOrString.isRequired,
    v: _propTypes.default.number.isRequired,
    opacity: _propTypes.default.number,
    color: _propTypes.default.string
  }).isRequired)
}).isRequired);
exports.propTypeGroupedSeries = propTypeGroupedSeries;
var propTypeMargin = _propTypes.default.shape({
  left: _propTypes.default.number,
  right: _propTypes.default.number,
  top: _propTypes.default.number,
  bottom: _propTypes.default.number
});
exports.propTypeMargin = propTypeMargin;
var propTypeVennData = _propTypes.default.arrayOf(_propTypes.default.shape({
  k: _propTypes.default.string.isRequired,
  v: _propTypes.default.number.isRequired
}).isRequired);
exports.propTypeVennData = propTypeVennData;